import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import { leadFormStateOptions } from '@/features/publicCompanyLeadsFunnel/constants/leadFormStateOptions.constant'
import { usePublicCompanyLead } from '@/features/publicCompanyLeadsFunnel/hooks/usePublicCompanyLead'
import { useParams } from 'react-router-dom'

const Update = () => {
  const { id } = useParams()

  const {
    data: publicClientCompanyLead,
    isPending: publicClientCompanyLeadIsPending,
    error: publicClientCompanyLeadError = {} as any,
    refetch: refetchPublicClientCompanyLead,
  } = usePublicCompanyLead(id || '')

  if (publicClientCompanyLeadIsPending) return <Box>Carregando...</Box>

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={publicClientCompanyLeadError?.status}
      refetchFunction={refetchPublicClientCompanyLead}
      notFoundButtonText='Ir para Funil de clientes públicos'
    >
      {!publicClientCompanyLeadIsPending && publicClientCompanyLead && id && (
        <>
          {leadFormStateOptions.map(({ value, comp: Comp }) => {
            if (publicClientCompanyLead.state !== value) return null
            return <Comp key={publicClientCompanyLead.id} id={id} publicCompanyLead={publicClientCompanyLead} />
          })}
        </>
      )}
    </ErrorMessageWrapper>
  )
}

export default Update
